<script>
  import { onDestroy, createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import { getGroupStore } from '@stores/group';
  let recObjectsStore = getGroupStore('recObjectsStore');
  let searchTermStore = getGroupStore('searchTermStore');

  const dispatch = createEventDispatcher();

  export let recObjectId;
  export let showModal = false;
  export let mobile = false;

  let recObject = recObjectsStore.find(recObjectId);
  let categories = [];

  let unsubRecObject = recObject.subscribe((x) => {
    recObject = x;
    categories = recObject.categories || { data: [], total: 0 };
  });

  let close = function () {
    showModal = false;
    dispatch('close');
  };

  let searchCategory = function (category) {
    return function () {
      close();
      searchTermStore.set({ term: category.name.trim() });
    };
  };

  onDestroy(() => {
    unsubRecObject();
  });
</script>

<style style="text/scss" lang="scss">
  .ui-header {
    font-weight: 500;
    font-size: 16px;
  }

  .cat-name {
    padding: 8px;
    background: #f5f3fc;
    border-radius: 15px;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    cursor: pointer;
    border: 2px solid white;

    &:hover {
      border: 2px dashed #8e71ff;
    }
  }
</style>

<div class="svelte-modal">
  <Modal
    mobile={mobile}
    on:close={close}
    show={showModal}
    showCloseButton={true}
    fadeInDuration={200}
    style="border-radius: 16px; width: 490px">
    <div slot="content" style="text-align: center;">
      <div class="ui-header">Categories</div>

      <div style="text-align: left; margin-top: 45px; transition: 0.2s all;">
        {#each categories as cat}
          <div class="cat-name" on:click={searchCategory(cat)}>
            {cat.name}
          </div>
        {/each}
      </div>
    </div>
  </Modal>
</div>
